import { DomainPermissionSubscriber } from './domain-permission-subscriber.js'

export const subscribers = [DomainPermissionSubscriber]
